import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchConToken } from 'helpers/fetch';
import { useTranslation } from 'react-i18next';
import { getDataSession, validarExisteSucursalPrincipal } from 'views/Utils/Common';
import ListTable from 'components/table/ListTable';
import RenderButtons from 'components/table/RenderButtons';
import Swal from 'sweetalert2';
import { useGlobalState } from 'resources/GlobalStateContext';
import DeleteIcon from '@mui/icons-material/Delete';

const List = ({ match }) => {
    const { path } = match;
    const { t } = useTranslation('common');
    const { setGlobalTitulo } = useGlobalState();
    const [actualizarTabla, setActualizarTabla] = useState(false);
    const columns = [
        {
            renderCell: RenderButtons, headerName: '', maxWidth: 20, path: path, opciones: "editar" + (validarSucursal() ? ",asignar,asignarmanual,desvincular" : ""),
            asignarAutomatico: asignar, desvincular: desvincular
        },
        getDataSession('tienda') === 'MERCADOLIBRE' ? { field: 'id', headerName: 'Id', maxWidth: 20 } :
            { field: 'id', headerName: 'Id', maxWidth: 20, renderCell: (params) => (<a href={`${path + '/edit/' + params.row.id}`}>{params.value}</a>) },
        getDataSession('tienda') === 'MERCADOLIBRE' ? { field: 'clave_Atributo', headerName: 'Clave atributo', flex: 1 } :
            { field: 'clave_Atributo', headerName: 'Clave atributo', flex: 1, renderCell: (params) => (<a href={`${path + '/edit/' + params.row.id}`}>{params.value}</a>) },
        { field: 'nombre', headerName: 'Nombre', flex: 1 },
        { field: 'tiene_Values', headerName: 'Tiene valores', flex: 1, renderCell: (params) => (<span>{params.value ? 'S' : 'N'}</span>) },
        { field: 'es_Variante', headerName: 'Es variante', flex: 1, renderCell: (params) => (<span>{params.value ? 'S' : 'N'}</span>) }
    ];

    function validarSucursal() {
        return getDataSession('sucursal') !== getDataSession('sucursalPrincipal');
    }

    function asignar(atributo_id) {
        Swal.fire({
            title: `¿Desea relacionar el atributo?`,
            showCancelButton: true,
            confirmButtonText: 'Relacionar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                var asignacion = {
                    sucursalOrg: getDataSession('sucursal'),
                    sucursalDes: getDataSession('sucursalPrincipal'),
                    catalogoOrg: atributo_id,
                    catalogoDes: 0,
                    catalogoValorOrg: 0,
                    catalogoValorDes: 0,
                    asignarValores: true
                };
                fetchConToken(`categorias/AsginarAtributo`, asignacion, 'PUT').then((response) => {
                    if (response.hasOwnProperty('status')) {
                        Object.entries(response.errors).forEach((value) => {
                            Swal.fire('Error', value[0], 'error');
                            return;
                        });
                        return false;
                    } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                        Swal.fire('Error', response.mensajes[0], 'error');
                        return false;
                    }

                    Swal.fire('Asignación completa', 'Atributo Relacionado', 'success');
                    setActualizarTabla(true);
                    setActualizarTabla(false);
                });
            }
        });
    }

    function desvincular(atributo_id) {
        Swal.fire({
            title: `¿Desea desvincular el atributo?`,
            showCancelButton: true,
            confirmButtonText: 'Desvincular',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                var desvincular = {
                    sucursalOrg: getDataSession('sucursal'),
                    sucursalDes: getDataSession('sucursalPrincipal'),
                    catalogoOrg: atributo_id,
                    catalogoDes: 0,
                    catalogoValorOrg: 0,
                    catalogoValorDes: 0,
                    desvincularValores: true
                };
                fetchConToken(`categorias/DesvincularAtributo`, desvincular, 'PUT')
                    .then((response) => {
                        if (response.hasOwnProperty('status')) {
                            Object.entries(response?.errors).forEach(([ , value]) => {
                                Swal.fire('Error', value[0], 'error');
                                return;
                            });
                            return false;
                        } else if (response.hasOwnProperty('codigo')) {
                            Swal.fire('Error', response.mensajes[0], 'error');
                            return false;
                        }

                        Swal.fire('Exito', 'Atributo Desvinculado', 'success');
                        setActualizarTabla(true);
                        setActualizarTabla(false);
                    })
            }
        });
    }

    function eliminar() {
        Swal.fire({
            title: '¿Desea eliminar los Atributos?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: t('app.botones.eliminar'),
            cancelButtonText: t('app.botones.cancelar')
        }).then((result) => {
            if (result.isConfirmed) {
                var url = `Categorias/AtributosBySucursal?sucursal_id=${getDataSession('sucursal')}&emrpesa_id=${getDataSession('empresa')}&eliminarmk=false`;
                fetchConToken(url, null, 'DELETE').then((response) => {
                    if (response.hasOwnProperty('status')) {
                        Object.entries(response?.errors).forEach(([ , value]) => {
                            Swal.fire('Error', value[0], 'error');
                            return;
                        });
                        return false;
                    } else if (response.hasOwnProperty('codigo')) {
                        Swal.fire('Error', response.mensajes[0], 'error');
                        return;
                    }

                    Swal.fire('Exito', 'Atributos eliminadas correctamente', 'success');
                    setActualizarTabla(true);
                    setActualizarTabla(false);
                });
            }
        });
    }

    if (getDataSession('tienda') === 'MERCADOLIBRE') {
        const indexToRemove = columns.findIndex(column => column.headerName === '');
        if (indexToRemove !== -1) columns.splice(indexToRemove, 1);
    }

    if (getDataSession('sucursal') !== getDataSession('sucursalPrincipal') && getDataSession('tienda') !== 'MERCADOLIBRE') {
        columns.splice(1, 0, {
            field: 'padre.clave_Atributo', headerName: 'Cve. Orig.', width: 100, cellClassName: (params) => { return 'columna-art-padre' }, renderCell: (params) => (
                <a href={`${path + '/edit/' + params.row.padre?.id}`}>{params.row.padre ? params.row.padre.clave_Atributo : ''}</a>)
        });
        columns.splice(2, 0, {
            field: 'padre.nombre', headerName: 'Nom. Orig.', width: 100, cellClassName: (params) => { return 'columna-art-padre' }, renderCell: (params) => (
                <a href={`${path + '/edit/' + params.row.padre?.id}`}>{params.row.padre ? params.row.padre.nombre : ''}</a>)
        });
    }

    useEffect(() => {
        setGlobalTitulo(prev => ({
            ...prev,
            titulo: 'Atributos',
            subtitulo: 'Aqui se muestran todas las atributos por conexion'
        }));
        validarExisteSucursalPrincipal();
    }, [setGlobalTitulo]);

    return (
        <div className='container-fluid'>
            <div className='col-md-12'>
                <div className='col-md-12'>
                    {getDataSession('tienda') !== 'MERCADOLIBRE' && (<>
                        <Link to={`${path}/add`} className='btn btn-outline-primary'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='currentColor' className='bi bi-plus-square' viewBox='0 0 16 16'>
                                <path d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z' />
                                <path d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z' />
                            </svg>
                            &nbsp; Nuevo
                        </Link>&nbsp;&nbsp;&nbsp;
                    </>)}
                    {getDataSession('tienda') !== 'MERCADOLIBRE' && (<button className='btn btn-outline-danger' type='button' onClick={() => eliminar()}><DeleteIcon /> &nbsp;Eliminar Atributos</button>)}
                </div>
            </div>
            <div className='col-12 col-sm-12 col-md-12'>
                <ListTable
                    hideFiltroExtra
                    columns={columns}
                    path={path}
                    url={`Categorias/AtributosGetList?sucursal_Id=${getDataSession('sucursal')}`}
                    reload={actualizarTabla}
                />
            </div>
        </div>
    );
};

export { List };